import { useEffect, useState } from 'react';
import userInfo from 'hub-http/userInfo';
import { captureException } from '../utils/captureException';
import { gate } from 'hub-http/gates';
const useUserHasGate = check => {
  const [hasGate, setHasGate] = useState(false);
  useEffect(() => {
    async function fetchGate() {
      try {
        const {
          gates
        } = await userInfo({
          cached: false
        });
        setHasGate(gates.includes(check));
      } catch (err) {
        if (err instanceof Error) {
          captureException(err, ['useUserHasGate']);
        } else {
          captureException(new Error('Unknown error'), ['useUserHasGate']);
        }
      }
    }
    void fetchGate();
  }, [check]);
  return hasGate;
};
export const useHasDataSharingCompanyGate = () => {
  return useUserHasGate(gate('MultiAccountManagement:CompanyDataMirroring'));
};
export const useHasDataSharingTicketGate = () => {
  return useUserHasGate(gate('MultiAccountManagement:ConnectedDataTickets'));
};